import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { JhiAlert, JhiAlertService, JhiEventManager } from 'ng-jhipster';
import { Subscription } from 'rxjs/Subscription';

import { ALERTS_CHANGED, HTTP_ERROR_OCCURRED } from '../../../shared/constants';
import { Error, FieldError } from '../../../models';

@Component({
    selector: 'qms-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['alert.component.css']
})
export class AlertComponent implements OnInit, OnDestroy {
    /* If you get error about unknown 'qms-alert' tag, try to import ErrorModule in your @NgModule */

    public alerts: JhiAlert[];

    private changeSubscription: Subscription;
    private cleanHttpErrorListener: Subscription;

    constructor(private alertService: JhiAlertService,
                private eventManager: JhiEventManager,
                private translateService: TranslateService) {
        this.alerts = [];
        this.cleanHttpErrorListener = eventManager.subscribe(HTTP_ERROR_OCCURRED, (response) => {
            const httpResponse = response.content;
            /* Special cases where response could not be retrieved from server */
            switch (httpResponse.status) {
                case 0:
                    this.onConnectionRefused(httpResponse);
                    break;
                case 404:
                    this.onNotFound(httpResponse);
                    break;
                case 504:
                    this.onGatewayTimeout(httpResponse);
                    break;
                default:
                    this.onHttpError(httpResponse);
                    break;
            }
        });
    }

    public closeAlert(alert: JhiAlert) {
        this.alertService.closeAlert(alert.id);
        this.reloadAlerts();
    }

    ngOnInit() {
        this.reloadAlerts();

        // Subscription needed due to lack of notification from alertService.
        // Before the change, AlertComponent loads alerts on initialization and not update them after change.
        this.changeSubscription = this.eventManager.subscribe(ALERTS_CHANGED, () => {
            this.reloadAlerts();
        });
    }

    ngOnDestroy() {
        this.alerts = [];
        if (this.cleanHttpErrorListener) {
            this.eventManager.destroy(this.cleanHttpErrorListener);
        }
        if (this.changeSubscription) {
            this.eventManager.destroy(this.changeSubscription);
        }
    }

    private reloadAlerts() {
        this.alerts = this.alertService.get();
    }

    private onConnectionRefused(httpResponse: any) {
        this.addErrorAlert('Server not reachable.', 'error.serverNotReachable');
    }

    private onNotFound(httpResponse: any) {
        this.addErrorAlert('Not found.', 'error.notFound');
    }

    private onGatewayTimeout(httpResponse: any) {
        this.addErrorAlert('Timeout occurred. Please try again later.', 'error.gatewayTimeout');
    }

    private onHttpError(httpResponse: any) {
        if (httpResponse.text() !== '' && httpResponse.json()) {
            /* Received our error, so we can translate it for user */
            const error: Error = httpResponse.json();

            if (error.key == null) {
                this.handleUnexpectedError();
                return;
            }

            /* Log every error */
            if (error.message != null) {
                console.error(error.message);
            }

            /* We have some specific errors and common ones */
            switch (error.key) {
                case 'validation':
                    this.handleValidationError(error);
                    break;
                case 'idForbidden':
                case 'idMissing':
                    this.handleEntityError(error);
                    break;
                case 'incorrectQueueState':
                    this.handleIncorrectState(error, 'queueState');
                    break;
                case 'incorrectRegistrationState':
                    this.handleIncorrectState(error, 'registrationState');
                    break;
                default:
                    this.addErrorAlert(error.message, 'error.' + error.key, error.data);
                    break;
            }
        } else {
            this.handleUnexpectedError();
        }
    }

    private addErrorAlert(message, key?, data?) {
        message = (key && key !== null) ? key : message;

        this.alertService.error(message, data, null);
        this.reloadAlerts();
    }

    private handleValidationError(error: Error) {
        const fieldErrors: FieldError[] = error.data;
        for (let i = 0; i < fieldErrors.length; i++) {
            const fieldError: FieldError = fieldErrors[i];
            // Convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
            const convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
            const fieldName = this.translateService.instant(fieldError.objectName + '.' + convertedField);
            this.addErrorAlert('Error on field "' + fieldName + '"', 'error.' + fieldError.code, { fieldName });
        }
    }

    private handleEntityError(error: Error) {
        const entityKey: string = error.data.entityName;
        const entityName: string = this.translateService.instant(entityKey + '.entityName');
        this.addErrorAlert(error.message, 'error.' + error.key, { entityName });
    }

    private handleIncorrectState(error: Error, enumName: string) {
        const stateEnum: string = error.data.state;
        const state: string = this.translateService.instant(`${enumName}.${stateEnum}`);
        this.addErrorAlert(error.message, 'error.' + error.key, { state });
    }

    private handleUnexpectedError() {
        this.addErrorAlert('Unexpected error occurred. Please try again later.', 'error.unexpectedError');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/generic/alert/alert.component.ts